<template>
    <section>
        <h1 class="text-center">{{title}}</h1>
        <p class="text-center">{{desc}}</p>
        <v-row  v-for="(row, i) in rowsData" :key="i" class="ma-0" justify="center" >
            <v-col v-for="(chart) in row" :key="chart.id" v-if="chart.data && chart.data.length " :class="row.length > 1 ? 'col-md-6 col-sm-12':'col-12'"  >
                <chart-card :dataItem="chart" :filters="filters" :sectionName="name"></chart-card>
            </v-col>
        </v-row>
    </section>
</template>


<script lang="ts">
  import {Component, Prop, Watch} from 'vue-property-decorator';
  import BaseComponent from "@/components/base/BaseComponent";
  import ChartCard from '@/components/ChartCard.vue';
  import {DataItem, DisplayMode} from "@/models/general";
  import {Filters} from '@/models/Filters';
  import {organizeIntoRows} from "@/components/utils/position-utils";

  @Component({
    components: {
      ChartCard
    }
  })
  export default class VerticalsSection extends BaseComponent {

    @Prop({default: ''}) title!: string;
    @Prop({default: ''}) desc!: string;
    @Prop({default: ''}) name!: string;
    @Prop({default: null}) dataItems!: DataItem[];
    @Prop({type: Object, default: () => ({})}) filters!: Filters;

    @Watch('dataItems')
    onDataItemsChanged() {
      this.updateRowsData();
    }

    private rowsData: Array<DataItem[]> = []

    mounted() {
      this.updateRowsData()
    }

    isCentered(row: DataItem[]) {
      return row[0].displayMode == DisplayMode.Centered
    }

    //organizes dataItems into rows based on DisplayMode
    updateRowsData(): void {
      this.rowsData = organizeIntoRows(this.dataItems)
    }

  }
</script>

<style lang="scss" scoped>
    .v-select {
        margin: 10px;
    }
</style>
